import React, { Component, Suspense } from 'react'
import { BrowserRouter as HashRouter, Routes, Route } from 'react-router-dom'
import './scss/style.scss'
import PrivateRoute from './PrivateRoute' // ← import du composant
import Unauthorized from './views/pages/Unauthorized'
import NotFound from './views/pages/notfound'

const loading = (
  <div className="pt-3 text-center">
    <div className="sk-spinner sk-spinner-pulse"></div>
  </div>
)

const DefaultLayout = React.lazy(() => import('./layout/DefaultLayout'))
const Login = React.lazy(() => import('./views/pages/Login'))
const ForgotPassword = React.lazy(() => import('./views/pages/ForgotPassword'))
const ResetPassword = React.lazy(() => import('./views/pages/ResetPassword'))

class App extends Component {
  render() {
    return (
      <HashRouter>
        <Suspense fallback={loading}>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            {/* <Route path="/unauthorized" element={<Unauthorized />} /> */}

            {/* Route protégée */}
            <Route
              path="*"
              element={
                <PrivateRoute>
                  <DefaultLayout />
                </PrivateRoute>
              }
            />

            {/* Vraie 404 */}
            {/* <Route path="*" element={<NotFound />} /> */}

          </Routes>

       
        </Suspense>
      </HashRouter>
    )
  }
}

export default App
